var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessWaves(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1512 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4248 96.6038C52.2334 66.1338 48.8555 41.5679 48.8555 41.5679C48.8555 41.5679 52.2334 66.1492 56.4248 96.6038ZM56.4248 96.6038L63.987 151.639",
    stroke: "url(#paint0_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.159 150.297L86.1508 96.6042L71.1426 42.9121",
    stroke: "url(#paint1_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6738 45.168L115.883 96.6031L138.085 148.077",
    stroke: "url(#paint2_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.65 145.022C174.65 145.022 161.684 123.396 145.608 96.6033L116.566 48.1851",
    stroke: "url(#paint3_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.926 52.0229L175.34 96.6029L210.745 141.183",
    stroke: "url(#paint4_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.252 136.617L205.065 96.6041L163.871 56.5923",
    stroke: "url(#paint5_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.477 61.811L234.799 96.6027L281.114 131.394",
    stroke: "url(#paint6_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.216 125.615L264.525 96.604L213.857 67.5928",
    stroke: "url(#paint7_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.027 73.8486L294.258 96.6029L348.487 119.357",
    stroke: "url(#paint8_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.875 112.725L323.989 96.6039L267.096 80.4824",
    stroke: "url(#paint9_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.084 87.3911L353.728 96.6034L412.357 105.816",
    stroke: "url(#paint10_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.859 98.8132L383.447 96.6027L324.035 94.3916",
    stroke: "url(#paint11_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 101.471L413.171 96.6035L472.406 91.7363",
    stroke: "url(#paint12_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.987 84.7432L442.904 96.6041L384.82 108.465",
    stroke: "url(#paint13_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.633 115.265L472.629 96.6026L528.624 77.9404",
    stroke: "url(#paint14_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.355 71.4458L502.385 96.6031L449.414 121.76",
    stroke: "url(#paint15_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.955 127.85L532.087 96.6045L581.22 65.3594",
    stroke: "url(#paint16_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.301 59.7534L561.82 96.6025L517.34 133.452",
    stroke: "url(#paint17_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.453 138.411L591.552 96.6023C613.206 73.4642 630.645 54.7939 630.645 54.7939",
    stroke: "url(#paint18_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.355 50.4883L621.277 96.6038L588.205 142.719",
    stroke: "url(#paint19_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.486 146.265L651.01 96.6035L677.527 46.9414",
    stroke: "url(#paint20_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.275 44.1934C700.275 44.1934 691.512 67.6004 680.768 96.6035L661.236 149.014",
    stroke: "url(#paint21_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.469 96.6041C703.7 126.651 698.238 150.91 698.238 150.91C698.238 150.91 703.706 126.651 710.469 96.6041ZM710.469 96.6041C717.239 66.5562 722.695 42.2974 722.695 42.2974C722.695 42.2974 717.233 66.5562 710.469 96.6041Z",
    stroke: "url(#paint22_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.923 41.3291C744.923 41.3291 742.812 66.0337 740.19 96.6414C737.573 127.249 735.469 151.953 735.469 151.953C735.469 151.953 737.573 127.211 740.19 96.6031C742.812 65.9948 744.923 41.3291 744.923 41.3291Z",
    stroke: "url(#paint23_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.779 152.031C772.779 152.031 771.507 127.273 769.928 96.6033C768.342 65.9346 767.07 41.1763 767.07 41.1763",
    stroke: "url(#paint24_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.66 96.6032C793.877 66.372 789.268 41.9668 789.268 41.9668C789.268 41.9668 793.908 66.372 799.66 96.6032ZM799.66 96.6032L810.034 151.24",
    stroke: "url(#paint25_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.387 96.6035C839.212 125.914 847.135 149.574 847.135 149.574C847.135 149.574 839.212 125.907 829.387 96.6035ZM829.387 96.6035L811.633 43.6328",
    stroke: "url(#paint26_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.305 46.1816C834.305 46.1816 845.388 68.7058 859.131 96.6037L883.958 147.026L859.113 96.6037C845.376 68.7058 834.305 46.1816 834.305 46.1816Z",
    stroke: "url(#paint27_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.337 143.671C920.337 143.671 906.273 122.644 888.864 96.6032L857.385 49.5361L888.808 96.6032C906.273 122.644 920.337 143.671 920.337 143.671Z",
    stroke: "url(#paint28_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.91 53.6597L918.573 96.604L956.192 139.549",
    stroke: "url(#paint29_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.508 134.727L948.298 96.6032L905.094 58.4795",
    stroke: "url(#paint30_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.971 63.9229L978.032 96.6034L1026.08 129.284",
    stroke: "url(#paint31_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.87 123.312L1007.76 96.604L955.637 69.8965",
    stroke: "url(#paint32_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.154 76.3057L1037.49 96.6038L1092.82 116.901",
    stroke: "url(#paint33_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.87 110.169L1067.22 96.6039L1009.56 83.0391",
    stroke: "url(#paint34_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.91 89.9937L1096.95 96.6036L1155.98 103.213",
    stroke: "url(#paint35_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.13 96.1504L1126.68 96.6033L1067.22 97.0563",
    stroke: "url(#paint36_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.49 104.112L1156.4 96.6035L1215.32 89.0957",
    stroke: "url(#paint37_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.54 82.1553L1186.13 96.6032L1128.73 111.051",
    stroke: "url(#paint38_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.89 117.747L1215.84 96.6048L1270.82 75.4624",
    stroke: "url(#paint39_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.22 69.104L1245.59 96.6033L1193.95 124.102",
    stroke: "url(#paint40_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.85 130.013L1275.32 96.6034L1322.79 63.1934",
    stroke: "url(#paint41_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.58 57.8271L1305.05 96.6031L1262.52 135.38",
    stroke: "url(#paint42_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.88 140.116L1334.79 96.6033L1371.69 53.0908",
    stroke: "url(#paint43_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.18 49.0601L1364.51 96.6032M1364.51 96.6032C1347.54 122.912 1333.8 144.146 1333.8 144.146C1333.8 144.146 1347.5 122.912 1364.51 96.6032Z",
    stroke: "url(#paint44_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.31 147.402C1370.31 147.402 1380.99 124.709 1394.24 96.6038L1418.18 45.8057",
    stroke: "url(#paint45_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440.78 43.3794L1423.96 96.6032L1407.15 149.828",
    stroke: "url(#paint46_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1453.7 96.6041C1448.49 126.92 1444.28 151.394 1444.28 151.394C1444.28 151.394 1448.46 126.92 1453.7 96.6041ZM1453.7 96.6041L1463.12 41.814",
    stroke: "url(#paint47_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.31 41.1377C1485.31 41.1377 1484.47 65.8957 1483.42 96.6033L1481.55 152.069",
    stroke: "url(#paint48_linear_2300_14231)",
    strokeWidth: 0.253338,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2300_14231",
    x1: 44.649,
    y1: 41.568,
    x2: 72.3532,
    y2: 41.8744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2300_14231",
    x1: 62.7973,
    y1: 42.9122,
    x2: 117.735,
    y2: 44.1478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2300_14231",
    x1: 81.3278,
    y1: 45.1682,
    x2: 162.553,
    y2: 47.9886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2300_14231",
    x1: 100.419,
    y1: 48.1852,
    x2: 206.531,
    y2: 53.3063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2300_14231",
    x1: 120.238,
    y1: 52.0231,
    x2: 249.392,
    y2: 60.2773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2300_14231",
    x1: 140.969,
    y1: 56.5923,
    x2: 290.793,
    y2: 69.0024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2300_14231",
    x1: 162.724,
    y1: 61.8111,
    x2: 330.432,
    y2: 79.7758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2300_14231",
    x1: 185.68,
    y1: 67.5934,
    x2: 367.686,
    y2: 93.1753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2300_14231",
    x1: 209.876,
    y1: 73.8486,
    x2: 401.437,
    y2: 110.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2300_14231",
    x1: 235.465,
    y1: 80.4824,
    x2: 428.268,
    y2: 135.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2300_14231",
    x1: 262.482,
    y1: 87.3911,
    x2: 432.605,
    y2: 174.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2300_14231",
    x1: 291.002,
    y1: 94.3916,
    x2: 329.345,
    y2: 177.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2300_14231",
    x1: 321.011,
    y1: 91.7363,
    x2: 431.753,
    y2: 200.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2300_14231",
    x1: 352.526,
    y1: 84.7432,
    x2: 536.657,
    y2: 157.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2300_14231",
    x1: 385.499,
    y1: 77.9404,
    x2: 579.277,
    y2: 124.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2300_14231",
    x1: 419.962,
    y1: 71.4458,
    x2: 608.545,
    y2: 103.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2300_14231",
    x1: 455.637,
    y1: 65.3594,
    x2: 632.737,
    y2: 87.7668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2300_14231",
    x1: 492.609,
    y1: 59.7535,
    x2: 653.985,
    y2: 75.4268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2300_14231",
    x1: 530.716,
    y1: 54.7941,
    x2: 673.084,
    y2: 65.5058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2300_14231",
    x1: 569.814,
    y1: 50.4884,
    x2: 690.549,
    y2: 57.4559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2300_14231",
    x1: 609.743,
    y1: 46.9415,
    x2: 706.686,
    y2: 51.1069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2300_14231",
    x1: 650.387,
    y1: 44.1935,
    x2: 721.806,
    y2: 46.3336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2300_14231",
    x1: 691.438,
    y1: 42.2975,
    x2: 736.209,
    y2: 43.1087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2300_14231",
    x1: 732.846,
    y1: 41.3293,
    x2: 750.15,
    y2: 41.4482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2300_14231",
    x1: 765.478,
    y1: 41.1764,
    x2: 775.938,
    y2: 41.2198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2300_14231",
    x1: 783.498,
    y1: 41.967,
    x2: 821.512,
    y2: 42.5483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2300_14231",
    x1: 801.765,
    y1: 43.6329,
    x2: 866.723,
    y2: 45.3841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2300_14231",
    x1: 820.5,
    y1: 46.1818,
    x2: 911.284,
    y2: 49.7784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2300_14231",
    x1: 839.89,
    y1: 49.5363,
    x2: 954.827,
    y2: 55.7207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2300_14231",
    x1: 859.984,
    y1: 53.6598,
    x2: 997.15,
    y2: 63.3329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2300_14231",
    x1: 881.069,
    y1: 58.4796,
    x2: 1038.01,
    y2: 72.7918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2300_14231",
    x1: 903.256,
    y1: 63.9229,
    x2: 1076.81,
    y2: 84.4567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2300_14231",
    x1: 926.663,
    y1: 69.8965,
    x2: 1112.94,
    y2: 99.1447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2300_14231",
    x1: 951.385,
    y1: 76.3057,
    x2: 1144.74,
    y2: 118.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2300_14231",
    x1: 977.501,
    y1: 83.0391,
    x2: 1166.55,
    y2: 147.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2300_14231",
    x1: 1005.09,
    y1: 89.9937,
    x2: 1147.66,
    y2: 192.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2300_14231",
    x1: 1034.16,
    y1: 96.1504,
    x2: 1036.1,
    y2: 116.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2300_14231",
    x1: 1064.74,
    y1: 89.0957,
    x2: 1219,
    y2: 186.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2300_14231",
    x1: 1096.81,
    y1: 82.1553,
    x2: 1287.56,
    y2: 143.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2300_14231",
    x1: 1130.33,
    y1: 75.4624,
    x2: 1323.19,
    y2: 115.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2300_14231",
    x1: 1165.24,
    y1: 69.1046,
    x2: 1350.13,
    y2: 97.0371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2300_14231",
    x1: 1201.46,
    y1: 63.1934,
    x2: 1373.06,
    y2: 82.8121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2300_14231",
    x1: 1238.87,
    y1: 57.8272,
    x2: 1393.43,
    y2: 71.4667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2300_14231",
    x1: 1277.36,
    y1: 53.0909,
    x2: 1411.89,
    y2: 62.2707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2300_14231",
    x1: 1316.74,
    y1: 49.0602,
    x2: 1428.83,
    y2: 54.8816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2300_14231",
    x1: 1357,
    y1: 45.8058,
    x2: 1444.53,
    y2: 49.1248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2300_14231",
    x1: 1397.81,
    y1: 43.3795,
    x2: 1459.34,
    y2: 44.9435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2300_14231",
    x1: 1439.04,
    y1: 41.8141,
    x2: 1473.54,
    y2: 42.2916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2300_14231",
    x1: 1480.51,
    y1: 41.1378,
    x2: 1487.38,
    y2: 41.1566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessWaves);
export default __webpack_public_path__ + "static/media/processWaves.c48275161814165f1dbff6fd1754a7f5.svg";
export { ForwardRef as ReactComponent };